import { PageHead } from '../../components/primitives/PageHead'
import { useOrgConfig } from '../../lib/org-config-context'
import { AdminBrandingTab } from './AdminBrandingTab'
import { AdminThemeTab } from './AdminThemeTab'

const sectionHeadingStyle: React.CSSProperties = {
  fontFamily: 'var(--font-sans)',
  fontSize: 18,
  fontWeight: 600,
  color: 'var(--text)',
  margin: '0 0 4px',
}

const sectionSubStyle: React.CSSProperties = {
  fontFamily: 'var(--font-sans)',
  fontSize: 13,
  color: 'var(--text-2)',
  margin: '0 0 16px',
}

/** Superadmin-only Branding & Theme console: company identity + logo/favicon
 *  uploads and the colour theme, on one page. Gated to superadmin by the
 *  route (see router/routes.tsx) and the nav (nav-config.ts). */
export function BrandingThemePage(): JSX.Element {
  const org = useOrgConfig()

  return (
    <>
      <PageHead
        eyebrow="Admin"
        title="Branding & Theme"
        subtitle={`White-label ${org.appName}: company identity, logos, favicon, and the colour palette.`}
      />

      <section style={{ marginBottom: 40 }}>
        <h2 style={sectionHeadingStyle}>Branding</h2>
        <p style={sectionSubStyle}>Company name, sidebar glyph, app title, and uploaded logo/favicon images.</p>
        <AdminBrandingTab />
      </section>

      <section style={{ borderTop: '1px solid var(--border)', paddingTop: 24 }}>
        <h2 style={sectionHeadingStyle}>Theme</h2>
        <p style={sectionSubStyle}>Colour tokens applied across the app. Saved only when text stays readable (WCAG AA).</p>
        <AdminThemeTab />
      </section>
    </>
  )
}
